import BaseActionSummary from '@/modules/rules-engine/actions/base-action-summary';
import ReminderActionModel from '@/common/models/rules/actions/reminder-action-model';
import unKebabCase from '@/common/helpers/un-kebab-case';

export default {
    extends: BaseActionSummary,
    computed: {
        systemEventGroup() {
            return Object.keys(ReminderActionModel.SupportedEventGroups)
                .find(group => ReminderActionModel.SupportedEvents[group]
                    .includes(this.event.eventType));
        },
        relatedEvent() {
            switch (this.systemEventGroup) {
                case ReminderActionModel.SupportedEventGroups.subscription:
                    return this.action.role;
                case ReminderActionModel.SupportedEventGroups.invoice:
                    return 'past due';
                case ReminderActionModel.SupportedEventGroups.paymentCard:
                    return 'expiration';
                default:
                    return '...';
            }
        },
        relatedEventName() {
            return unKebabCase(this.relatedEvent);
        },
    },
};
